import React from 'react';
import Connect from '../Connect'

export default function Contact() {
  return  (
    <div id="Contact" >
      <Connect />
    </div>)
}